import React, { useEffect, useRef, useState } from 'react'
import { collection, getDocs } from 'firebase/firestore'
import { autocompleteClasses, Box, Button, Card, Container, Grid, Link, Modal, TableRow } from '@mui/material';
import { Routes } from 'react-router-dom';
import  brainImg  from "../../Media/brain.jpg";
import { textAlign } from '@mui/system';
import MainHero from '../MainScreenComponents/MainHero';


const MainScreen = () => {


  return (
    <div className="d-flex flex-column align-items-center">
      <MainHero/>

      <Box
        bgcolor='#11111f'
        color='white'
        px={{xs:3, sm: 10,}}
        py={{xs:5, sm: 10}}
      >
        <Container
          maxWidth='lg'
        >
          <Grid container spacing={5}>
              <Grid item xs={12} sm={4} >
                <Box borderBottom={1}>Ayuda</Box>
                  <Box>
                    <Link href='https://github.com/Felipe-os' target="_blank" color='inherit'>
                      Contacto
                    </Link>
                  </Box>
                  <Box>
                    <Link href='https://youtu.be/onGmoJA3diM' target="_blank" color='inherit'>
                      Tutorial
                    </Link>
                  </Box>
                <Box>
                  {/* <Link href='/' color='inherit'>
                    Politicas de privacidad
                  </Link> */}
                </Box>
              </Grid>
          </Grid>
          <Box textAlign='center' pt={{xs: 5, sm: 10}} pb={{xs: '100%', sm: 0}} >
            Felipe Ortiz &reg; {new Date().getFullYear()}
          </Box>
        </Container>
      </Box>

    </div>
  )
}

export default MainScreen